@let expandedValue = expanded();
@let isLongValue = isLong();

<div class="expandable-text">
  <span>{{ visiblePart() }}</span>
  @if (!expandedValue && isLongValue) {
    <span>&hellip;</span>
  }

  @if (isLongValue) {
    <div
      class="expandable-text__collapsible"
      [class.expandable-text__collapsible--open]="expandedValue"
    >
      <div class="expandable-text__inner">
        <span>{{ restPart() }}</span>
      </div>
    </div>

    <!-- eslint-disable pct-custom-ng-rules/no-mat-icon-svg-icon -->
    <button class="expandable-text__toggle" type="button" (click)="toggle()">
      {{ expandedValue ? 'Kevesebb mutatása' : 'Több mutatása' }}
      <mat-icon
        class="expandable-text__icon"
        svgIcon="pct-mdi-chevron-down"
        [class.expandable-text__icon--open]="expanded()"
      />
    </button>
  }
</div>
